<script>
  const API_URL = process.env.API_SERVER_URL

  export default {
    urls: {
      articles: API_URL + '/content/articles/',
      article: API_URL + '/content/article/',

      article_update_title: API_URL + '/article/title/',
      article_update_intro: API_URL + '/article/intro/',
      article_update_content: API_URL + '/article/content/'
    }
  }
</script>



// WEBPACK FOOTER //
// Config.vue?294171c6